function initRebuyFbtProgress() {
  const widget = document.querySelector("#rebuy-widget-224481");

  if (!widget || widget.dataset.progressReady === "true") return;

  const track = widget.querySelector(".splide__track");
  const list = widget.querySelector(".splide__list");
  const content = widget.querySelector(".rebuy-widget-content");

  if (!track || !list || !content) return;

  const progress = document.createElement("div");
  progress.className = "as-rebuy-fbt-progress";
  progress.innerHTML = "<span></span>";

  content.appendChild(progress);

  const fill = progress.querySelector("span");

  const update = () => {
    const max = list.scrollWidth - track.clientWidth;
    const current = Math.abs(
      parseFloat(list.style.transform.replace(/[^\d.-]/g, "")) || 0,
    );

    const percent = max > 0 ? Math.min(current / max, 1) : 0;

    fill.style.width = "45%";
    fill.style.transform = `translateX(${percent * 122}%)`;
  };
  update();

  const observer = new MutationObserver(update);
  observer.observe(list, {
    attributes: true,
    attributeFilter: ["style"],
  });

  widget.dataset.progressReady = "true";
}

document.addEventListener("DOMContentLoaded", () => {
  initRebuyFbtProgress();

  setTimeout(initRebuyFbtProgress, 500);
  setTimeout(initRebuyFbtProgress, 1000);
  setTimeout(initRebuyFbtProgress, 2000);
  setTimeout(initRebuyFbtProgress, 4000);
});

document.addEventListener("rebuy:cart.show", initRebuyFbtProgress);
document.addEventListener("rebuy:cart.change", initRebuyFbtProgress);

setInterval(initRebuyFbtProgress, 1000);

function initRebuyFbtHeader() {
  const widget = document.querySelector("#rebuy-widget-224481");

  if (!widget || widget.dataset.headerReady === "true") return;

  const title = widget.querySelector(".primary-title");
  const content = widget.querySelector(".rebuy-widget-content");

  if (!title || !content) return;

  const wrapper = document.createElement("div");
  wrapper.className = "as-rebuy-fbt-header";

  const subtitle = document.createElement("p");
  subtitle.className = "as-rebuy-fbt-subtitle";
  subtitle.innerHTML = "Get the most our of your FREE shipping";

  title.parentNode.insertBefore(wrapper, title);

  wrapper.appendChild(title);
  wrapper.appendChild(subtitle);

  widget.dataset.headerReady = "true";
}

document.addEventListener("DOMContentLoaded", () => {
  initRebuyFbtHeader();

  setTimeout(initRebuyFbtHeader, 500);
  setTimeout(initRebuyFbtHeader, 1000);
  setTimeout(initRebuyFbtHeader, 2000);
});

document.addEventListener("rebuy:cart.show", initRebuyFbtHeader);
document.addEventListener("rebuy:cart.change", initRebuyFbtHeader);

setInterval(initRebuyFbtHeader, 1000);
